
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal/PortalHome",
      function () {
        return require("private-next-pages/portal/PortalHome.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal/PortalHome"])
      });
    }
  